import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

let firebaseConfig = null;
let isFirebaseEnabled = false;
try {
  // eslint-disable-next-line import/no-dynamic-require
  const {
    firebaseConfig: ssoFirebaseConfig,
    enabled: ssoEnabled,
  } = require("../../src-dynamic/destination.sso.js");

  firebaseConfig = ssoFirebaseConfig;
  isFirebaseEnabled = ssoEnabled;
} catch (e) {
  // do nothing if the file does not exist
}

let app = null;
let auth = null;

function getFirebaseApp() {
  if (!isFirebaseEnabled) {
    return null;
  }
  if (!app) {
    if (getApps().length === 0) {
      app = initializeApp(firebaseConfig);
    } else {
      app = getApps()[0];
    }
  }
  return app;
}

function getFirebaseAuth() {
  const application = getFirebaseApp();
  if (!application) return null;
  if (!auth) {
    auth = getAuth(application);
  }
  return auth;
}

export function isFirebaseConfigured() {
  return new Boolean(isFirebaseEnabled);
}

export { getFirebaseApp, getFirebaseAuth };
